import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import Divider from '../../images/Divider.svg'
import DividerW from '../../images/DividerW.svg'
import Fill from '../../images/Fill.svg'

export const query = graphql`
  query services {
    bdlogo: file(relativePath: {eq: "SBd.png"}) {
      bdlogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 250, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    wslogo: file(relativePath: {eq: "SWs.png"}) {
      wslogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 400, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    dmlogo: file(relativePath: {eq: "SDm.png"}) {
      dmlogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 250, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    }
  }
  `

const Services = ({data:{bdlogo, wslogo, dmlogo}}) => (
  <section>
    <article>
      <div className='container'>
        <div className='full-Width'>
          <div className='half-Width-25 mobBottommargin' style={{}}>
            <div style={{display:'block'}}>
              <h1 className='smallerHone'>Services</h1>
              <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
              <p><span className='biggerText gradient'>Strategy, design and a bit of magic.</span></p>
              <p style={{marginBottom:'0'}}>Nisadhya Pvt. Ltd is a Nepal based Digital Marketing Company that constantly strives to provide the best branding and digital marketing solutions.</p>
            </div>
          </div>
          <div className='half-Width-75 homeServicesContainer paddingLeft spaceBetween' style={{alignItems: 'baseline'}}>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices'>
                <Img sizes={dmlogo.dmlogochild.sizes} alt="Social Media's impact on Business" style={{maxWidth:'175px', margin:'0 auto', marginBottom:'.75rem'}}/>
                <Link to="/services/digital-marketing/" className='slide'><span>Digital Marketing</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem auto'}}/>
                Social Media<br/>
                Google Ads<br/>
                SEO
              </div>
            </div>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices'>
                <Img sizes={wslogo.wslogochild.sizes} alt="Social Media's impact on Business" style={{maxWidth:'175px', margin:'0 auto', marginBottom:'.75rem'}}/>
                <Link to="/services/web-solutions/" className='slide'><span>Web Solutions</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem auto'}}/>
                <Link to="/services/web-solutions/website-design/" className='slide'>Website Design</Link><br/>
                <Link to="/services/web-solutions/website-design/" className='slide'>Website Development</Link><br/>
                <Link to="/services/web-solutions/website-design/" className='slide'>Web Hosting</Link>
              </div>
            </div>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices' style={{marginBottom:'0'}}>
                <Img sizes={bdlogo.bdlogochild.sizes} alt="Social Media's impact on Business" style={{maxWidth:'175px', margin:'0 auto', marginBottom:'.75rem'}}/>
                <Link to="/services/brand-development/" className='slide'><span>Brand Development</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem auto'}}/>
                Corporate Branding<br/>
                Logo Design<br/>
                Brand Strategy
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>
)

export default Services



// WEBPACK FOOTER //
// ./src/pages/services/index.js